import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, ListGroup, Row, Spinner } from "react-bootstrap";
import { FaSwimmingPool } from "react-icons/fa";
import { TbTruckDelivery, TbCoins } from "react-icons/tb";
import { HiXMark } from 'react-icons/hi2';
import PrivateApi from "../../services/PrivateApiService";
import { useQueryClient } from "react-query";
import { FaRegFileZipper } from "react-icons/fa6";
import DownloadZipItem from "./DownloadZipItem";
import { useAuthState } from "../../context/AuthContext";


/**
 * DownloadList
 * 
 * list to display all invoices and allow customer to download them
 * 
 * @param {props} invoices array of invoices to be displayed
 * @returns gui list of invoices
 */
const DownloadList = (props) => {

    const API = new PrivateApi(); // API calls
    const { user } = useAuthState();
    const queryClient = useQueryClient();
    const [view, setView] = useState("invoices");
    const [selectedInvoices, setSelectedInvoices] = useState(); // array state of invoices to display
    const [download_list, setDownload_list] = useState([]); // array state of invoices to be downloaded
    const [downloadCount, setDownloadCount] = useState(0);  // number state of selected invoices to download

    const [downloadBtnHidden, setDownloadBtnHidden] = useState(true); // bool state to show/hide download btn
    const [downloadBtnLoading, setDownloadBtnLoading] = useState(false); // bool state when download is loading

    const [zipList, setZipList] = useState([]);


    // initial Effect to sort passed invoices through props
    useEffect(() => {
        if (props.invoices) {
            setSelectedInvoices(props.invoices.sort((a, b) => new Date(a.x_rechnungsdatum ? a.x_rechnungsdatum : a.x_eingangsdatum ? a.x_eingangsdatum : a.create_date) - new Date(b.x_rechnungsdatum ? b.x_rechnungsdatum : b.x_eingangsdatum ? b.x_eingangsdatum : b.create_date)).reverse());
            uncheckAll();
        }
    }, [props.invoices]);


    // Effect triggers when download list changes
    useEffect(() => {
        setDownloadCount(download_list.length);
    }, [download_list])


    // Function to check all checkboxes
    const checkAll = (value) => {
        var checkboxes = document.getElementsByClassName('form-check-input');
        if (value) {
            var d_list = [];
            for (var i = 1; i < checkboxes.length; i++) {
                checkboxes[i].checked = true;
                d_list.push({ "type": checkboxes[i].id.split(":")[0], "id": checkboxes[i].id.split(":")[1] });
            }
            setDownload_list(d_list);
            setDownloadBtnHidden(false);

        } else {
            for (var x = 1; x < checkboxes.length; x++) {
                checkboxes[x].checked = false;
            }
            setDownload_list([]);
            setDownloadBtnHidden(true);
        }
    }

    // Function to uncheck all checkboxes
    const uncheckAll = () => {
        var checkboxes = document.getElementsByClassName('form-check-input');
        for (var i = 0; i < checkboxes.length; i++) {
            checkboxes[i].checked = false;
        }
        setDownload_list([]);
        setDownloadBtnHidden(true);
    }

    // Function to check single checkbox
    const checkSingle = (value) => {
        var d_list = [...download_list];
        if (value.target.checked) {
            var obj = { "type": value.target.id.split(":")[0], "id": value.target.id.split(":")[1] };
            d_list.push(obj);
            setDownload_list(d_list);
        } else {
            d_list = download_list.filter(d => d.id !== value.target.id.split(":")[1]);
            setDownload_list(d_list);
        }
        if (d_list.length > 0) setDownloadBtnHidden(false);
        else setDownloadBtnHidden(true);
    }


    const createFiles = (files) => {
        if (files !== undefined && files.file !== null && files.file !== undefined) {
            const linkSource = `data:application/pdf;base64,${files.file}`;
            const fileName = files.name + '.pdf';
            const donwloadLink = document.createElement('a');

            donwloadLink.href = linkSource;
            donwloadLink.download = fileName;
            donwloadLink.click();
        }
    }


    const downloadBtnHandler = () => {
        if (download_list.length === 1) {
            setDownloadBtnLoading(true);
            API.get_InvoiceSingleDownload(`${download_list[0].type}:${download_list[0].id}`)
                .then(res => {
                    let data = res.data.files;
                    createFiles(data[0]);
                    setDownloadBtnLoading(false);
                    download_list.forEach(item => {
                        var element = document.getElementById(`${item.type}:${item.id}`);
                        element.style.display='none';
                    });
                    uncheckAll();
                    queryClient.invalidateQueries("GET_ALL_INVOICES");
                })
                .catch(err => {
                    setDownloadBtnLoading(false);
                })
        } else {
            setView('preparing');
            API.post_InvoicePrepare(download_list)
                .then(res => {
                    setZipList(res.data); 
                    setView("download");
                })
        }
    }


    // GUI
    return (
        <Card style={{borderRadius: "15px", borderLeft: "3px solid #a2c13f", borderBottom: "3px solid #a2c13f"}} className="shadow-lg">
            {view === "invoices" ? 
                <>
                    <Row className="mt-4" style={{ marginLeft: "4px", marginRight: "4px" }}>
                        <Col key="checkboxes" xs="10" md="1" xl="1"><Form.Check onChange={e => checkAll(e.target.checked)} type="checkbox" /></Col>
                        <Col key="von" xs="2" md="2" xl="2">Von</Col>
                        <Col key="rechnungsart" xs="12" md="5" xl="5">Rechnungsart</Col>
                        <Col key="datum" xs="12" md="2" xl="2">Datum</Col>
                        <Col key="downloaded" xs="12" md="2" xl="2" className="text-center">
                            {downloadBtnHidden ? 'Downloaded' :
                                downloadBtnLoading ?
                                    <>
                                        <Spinner size="sm" className="text-energo" />&nbsp;Download wird vorbereitet
                                    </>
                                    :
                                    <Button className="btn-energo" onClick={() => downloadBtnHandler()}>Download ({downloadCount})</Button>
                            }
                        </Col>
                    </Row>
                    <ListGroup className="mt-3">
                        {selectedInvoices && selectedInvoices.length > 0 ? selectedInvoices.map(inv => (
                            <>
                                {inv.x_datum_download === 'False' ?
                                    <ListGroup.Item
                                        key={inv.x_rechnungsdatum ? `poolrechnung:${inv.id}` : inv.x_eingangsdatum ? `abrechnung:${inv.id}` : `vorschreibung:${inv.id}`}
                                        id={inv.x_rechnungsdatum ? `poolrechnung:${inv.id}` : inv.x_eingangsdatum ? `abrechnung:${inv.id}` : `vorschreibung:${inv.id}`}
                                        className="mb-2"
                                        style={{
                                            height: "auto",
                                            paddingTop: "10px"
                                        }}
                                    >
                                        <Row className="align-items-center">
                                            <Col xs="10" xl="1">
                                                <Form.Check
                                                    type="checkbox"
                                                    id={inv.x_rechnungsdatum ? `poolrechnung:${inv.id}` : inv.x_eingangsdatum ? `abrechnung:${inv.id}` : inv.x_datum_tzb_einzug ? `vorschreibung:${inv.id}` : null}
                                                    onChange={e => checkSingle(e)} />
                                            </Col>
                                            <Col xs="2" xl="2">
                                                {
                                                    inv.x_rechnungsdatum ? <FaSwimmingPool className="text-energo rounded" size="30" />
                                                        :
                                                        inv.x_eingangsdatum ? <TbTruckDelivery className="text-primary" size="30" />
                                                            :
                                                            inv.x_datum_tzb_einzug ? <TbCoins className="text-warning" size="30" />
                                                                :
                                                                null
                                                }
                                            </Col>
                                            <Col xs="12" xl="5">
                                                <b>
                                                    {
                                                        inv.x_rechnungsdatum ? inv.x_rechnungsart + ' ENERGO'
                                                            :
                                                            inv.x_eingangsdatum ?
                                                                inv.x_is_final_invoice ? 'Endrechnung Energie' : 'Abrechnung Energie'
                                                                :
                                                                inv.x_datum_tzb_einzug ? 'Vorschreibung'
                                                                    :
                                                                    null
                                                    }
                                                </b>
                                            </Col>
                                            <Col xs="6" xl="2">
                                                <span className="text-muted">
                                                    {
                                                        inv.x_rechnungsdatum ? new Date(inv.x_rechnungsdatum).toLocaleDateString('DE-de')
                                                            :
                                                            inv.x_eingangsdatum ? new Date(inv.x_eingangsdatum).toLocaleDateString('DE-de')
                                                                :
                                                                inv.x_datum_tzb_einzug ? new Date(inv.create_date).toLocaleDateString('DE-de')
                                                                    :
                                                                    null
                                                    }
                                                </span>
                                            </Col>
                                            <Col xl="2" className="text-center">
                                                {
                                                    inv.x_datum_download === 'False' ? <HiXMark size="20" className="text-danger" />
                                                        :
                                                        new Date(inv.x_datum_download).toLocaleDateString('DE-de')
                                                }
                                            </Col>
                                        </Row>
                                    </ListGroup.Item>

                                    : null}
                                {inv.x_datum_download_storno === 'False' && inv.x_file_stornorechnung_name !== 'False' ?
                                    <ListGroup.Item
                                        key={inv.x_rechnungsdatum ? `stornoP:${inv.id}` : inv.x_eingangsdatum ? `stornoA:${inv.id}` : `stornoP:${inv.id}`}
                                        className="mb-2"
                                        style={{
                                            height: "auto",
                                            paddingTop: "10px"
                                        }}
                                    >
                                        <Row className="align-items-center">
                                            <Col xs="10" xl="1">
                                                <Form.Check
                                                    type="checkbox"
                                                    id={inv.x_rechnungsdatum ? `stornoP:${inv.id}` : inv.x_eingangsdatum ? `abrechnung:${inv.id}` : inv.x_datum_tzb_einzug ? `stornoV:${inv.id}` : null}
                                                    onChange={e => checkSingle(e)} />
                                            </Col>
                                            <Col xs="2" xl="2">
                                                {
                                                    inv.x_rechnungsdatum ? <FaSwimmingPool className="text-energo rounded" size="30" />
                                                        :
                                                        inv.x_eingangsdatum ? <TbTruckDelivery className="text-primary" size="30" />
                                                            :
                                                            inv.x_datum_tzb_einzug ? <TbCoins className="text-warning" size="30" />
                                                                :
                                                                null
                                                }
                                            </Col>
                                            <Col xs="12" xl="5">
                                                <b className="text-danger">
                                                    {
                                                        inv.x_rechnungsdatum ? inv.x_rechnungsart + ' ENERGO'
                                                            :
                                                            inv.x_eingangsdatum ? 'Stornorechnung Energie'
                                                                :
                                                                inv.x_datum_tzb_einzug ? 'Vorschreibung Storno'
                                                                    :
                                                                    null
                                                    }
                                                </b>
                                            </Col>
                                            <Col xs="6" xl="2">
                                                <span className="text-muted">
                                                    {
                                                        inv.x_rechnungsdatum ? new Date(inv.x_rechnungsdatum).toLocaleDateString('DE-de')
                                                            :
                                                            inv.x_eingangsdatum ? new Date(inv.x_eingangsdatum).toLocaleDateString('DE-de')
                                                                :
                                                                inv.x_datum_tzb_einzug ? new Date(inv.x_datum_tzb_einzug).toLocaleDateString('DE-de')
                                                                    :
                                                                    null
                                                    }
                                                </span>
                                            </Col>
                                            <Col xl="2" className="text-center">
                                                {
                                                    inv.x_datum_download === 'False' || inv.x_datum_download_storno === 'False' ?
                                                        <HiXMark size="20" className="text-danger" />
                                                        :
                                                        new Date(inv.x_datum_download).toLocaleDateString('DE-de')
                                                }
                                            </Col>
                                        </Row>
                                    </ListGroup.Item>
                                    : null}
                                {inv.x_file_mahnung_name !== undefined && inv.x_file_mahnung_name !== 'False' && inv.x_datum_download_mahnung === 'False' ?
                                    <ListGroup.Item
                                        key={inv.x_rechnungsdatum ? `mahnungP:${inv.id}` : inv.x_eingangsdatum ? `mahnungA:${inv.id}` : `mahnungV:${inv.id}`}
                                        className="mb-2"
                                        style={{
                                            height: "auto",
                                            paddingTop: "10px"
                                        }}
                                    >
                                        <Row className="align-items-center">
                                            <Col xs="10" xl="1">
                                                <Form.Check
                                                    type="checkbox"
                                                    id={inv.x_rechnungsdatum ? `poolrechnung:${inv.id}` : inv.x_eingangsdatum ? `abrechnung:${inv.id}` : inv.x_datum_tzb_einzug ? `vorschreibung:${inv.id}` : null}
                                                    onChange={e => checkSingle(e)} />
                                            </Col>
                                            <Col xs="2" xl="2">
                                                {
                                                    inv.x_rechnungsdatum ? <FaSwimmingPool className="text-energo rounded" size="30" />
                                                        :
                                                        inv.x_eingangsdatum ? <TbTruckDelivery className="text-primary" size="30" />
                                                            :
                                                            inv.x_datum_tzb_einzug ? <TbCoins className="text-warning" size="30" />
                                                                :
                                                                null
                                                }
                                            </Col>
                                            <Col xs="12" xl="5">
                                                <b className="text-warning">
                                                    {
                                                        inv.x_rechnungsdatum ? inv.x_rechnungsart + ' ENERGO'
                                                            :
                                                            inv.x_eingangsdatum ? 'Mahnung Energie'
                                                                :
                                                                inv.x_datum_tzb_einzug ? 'Mahnung Vorschreibung'
                                                                    :
                                                                    null
                                                    }
                                                </b>
                                            </Col>
                                            <Col xs="6" xl="2">
                                                <span className="text-muted">
                                                    {
                                                        inv.x_rechnungsdatum ? new Date(inv.x_rechnungsdatum).toLocaleDateString('DE-de')
                                                            :
                                                            inv.x_eingangsdatum ? new Date(inv.x_eingangsdatum).toLocaleDateString('DE-de')
                                                                :
                                                                inv.x_datum_tzb_einzug ? new Date(inv.create_date).toLocaleDateString('DE-de')
                                                                    :
                                                                    null
                                                    }
                                                </span>
                                            </Col>
                                            <Col xl="2" className="text-center">
                                                {
                                                    inv.x_datum_download === 'False' || inv.x_datum_download_mahnung === 'False' ?
                                                        <HiXMark size="20" className="text-danger" />
                                                        :
                                                        new Date(inv.x_datum_download).toLocaleDateString('DE-de')
                                                }
                                            </Col>
                                        </Row>
                                    </ListGroup.Item>
                                    : null}
                            </>
                        )) :
                            <ListGroup.Item key="none:0">
                                Keine Dokumente...
                            </ListGroup.Item>
                        }
                    </ListGroup>
                </> :
            view === "preparing" ? 
                <>
                    <Card.Body className="text-center">
                        <div className="mt-5 mb-5">
                            <h4><Spinner className="text-energo" animation="border" /></h4>
                            <h5>Download wird vorbereitet</h5>
                        </div>
                    </Card.Body>
                </> :
            view === "download" ? 
                <Card.Body>
                    <div className="mt-1 mb-5">
                        <h4>Dokumente zum Download bereit</h4>
                        <hr />
                        {user.x_is_house_management === true?
                            <p className="text-muted">Die Dateien sind ab sofort auch im Archiv verfügbar</p>
                            :
                            null
                        }
                        <Row className="mt-4 justify-content-center">
                            <Col xl="12">
                                <ul style={{listStyle: "none", paddingLeft: 0}}>
                                    {zipList.map(zip => (
                                        <DownloadZipItem zip={zip} />
                                    ))}
                                </ul>
                            </Col>
                        </Row>
                        
                    </div>
                </Card.Body> :
                null
            }
        </Card>
    )
}

export default DownloadList;